<template>
  <router-link 
    v-if="href" 
    :to="href" 
    data-component="Widget/Button" 
    :class="`inline-flex items-center justify-center font-semibold text-white bg-lightblue rounded transition-colors duration-250 border-0 no-underline hover:bg-lightblue2 focus:bg-lightblue active:bg-lightblue disabled:opacity-50 ${className} ${loading ? 'is-loading' : ''}`"
    v-bind="$attrs"
  >
    <div v-if="loading" class="spinner"></div>
    <span :class="{ 'opacity-0': loading }">
      <slot></slot>
    </span>
  </router-link>
  <button 
    v-else
    data-component="Widget/Button" 
    :class="`inline-flex items-center justify-center font-semibold text-white bg-lightblue rounded transition-colors duration-250 border-0 hover:bg-lightblue2 focus:bg-lightblue active:bg-lightblue disabled:opacity-50 ${className} ${loading ? 'is-loading' : ''}`"
    v-bind="$attrs"
  >
    <div v-if="loading" class="spinner"></div>
    <span :class="{ 'opacity-0': loading }">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'VButton',
  inheritAttrs: false,
  props: {
    className: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
